import { render, staticRenderFns } from "./CartNote.vue?vue&type=template&id=2c227a79"
import script from "./CartNote.vue?vue&type=script&lang=js"
export * from "./CartNote.vue?vue&type=script&lang=js"
import style0 from "./CartNote.vue?vue&type=style&index=0&id=2c227a79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports